import { ReactNode } from 'react';

import { Heading } from '@/components/typography/heading';

import styles from './section.module.scss';

export type SectionProps = {
  title: string;
  children: ReactNode;
  testId?: string;
  headerContent?: ReactNode;
};

export type SubsectionProps = {
  children: ReactNode;
  testId?: string;
  title?: string;
};

export function Section( { title, children, testId, headerContent }: SectionProps ) {
  const heading = (
    <Heading as="h3" size="md" data-testid={ testId ? `${ testId }-title` : undefined }>
      {title}
    </Heading>
  );

  return (
    <div className={ styles.section } data-testid={ testId }>
      {headerContent ? (
        <div className={ styles.sectionHeader }>
          {heading}
          {headerContent}
        </div>
      ) : heading}
      <div className={ styles.content }>
        {children}
      </div>
    </div>
  );
}

export function Subsection( { children, testId, title }: SubsectionProps ) {
  return (
    <div className={ styles.subsection } data-testid={ testId }>
      {title && <Heading as="h4" size="md">{title}</Heading>}
      {title && <div style={ { height: '10px' } } />}
      {children}
    </div>
  );
}
